import React, { useState, useEffect } from "react";
import CustomTable from "../organisms/CustomTable";
import { ReactComponent as UploadProject } from "../svgs/project-upload.svg";
import TransitionWrapper from "../atoms/TransitionWrapper/index.jsx";
import { useNavigate } from "react-router-dom";
import Button from "../atoms/Button/index.jsx";
import { useDispatch, useSelector } from "react-redux";
import { yourProjetsData } from "../../utils/API/yourProjectsData.js";
import ToggleButton from "../atoms/ToggleButton/index.jsx";
import AddCreditsPopup from "../molecules/AddCreditsPopUp/index.jsx";
import AcceptPopUp from "../molecules/AcceptPopUp/index.jsx";
import { Skeleton } from "antd";
import SearchBar from "../atoms/SearchButton/index.jsx";
import FilterBox from "../molecules/FilterBoxPage";
import { ReactComponent as Filter } from "../svgs/filter.svg";
import toast from "react-hot-toast";
import Pagination from "../atoms/Pagination";
import { useSearchParams } from "react-router-dom";
import Badge from "../atoms/Badge/index.jsx";
import DownloadButton from "../atoms/DownloadButton/index.jsx";
import { addMoreCredit } from "../../utils/API/addMoreCredit.js";
import ProjectRemrks from "../atoms/ProjectsRemarks/index.jsx";
import ProjectsRemarks from "../atoms/ProjectsRemarks/index.jsx";

const getLabel = {
  verified: "Verified",
  requested: "Requested",
  action_required: "Action Required",
  under_verification: "Under Verification",
  not_verified: "Not Verified",
  sent_for_approval: "Sent for Approval",
};

const ActionButtons = ({ addCreditButtonHandler }) => {
  return (
    <Button
      color={"blue"}
      varient={"secondary"}
      onClick={addCreditButtonHandler}
      className={"text-white px-7 text-[9px] py-1.5 font-bold"}
    >
      Add
    </Button>
  );
};

const ProjectsPage = ({ showCompletePage = true }) => {
  const dispatch = useDispatch();
  const [projectsData, setProjectsData] = useState([]);
  const [selectedToggle, setSelectedToggle] = useState("Ongoing");
  const [isAddCreditOpen, setAddCreditOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isAddCreditSubmit, setAddCreditSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [searchItem, setSearchItem] = useState("");
  const [isFilterDialogOpen, setFilterDialogOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedRegistry, setSelectedRegistry] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  // const [selectedToken, setSelectedToken] = useState("");
  const [filterData, setFilterData] = useState(null);
  const [showRemarksPopup, setShowRemarksPopup] = useState(false);
  const [projectId, setProjectId] = useState(false);
  const currentPage = Number(searchParams.get("page")) || 1;
  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0,
  });
  const headerData1 = [
    "Project Name",
    "Project ID",
    "Category",
    "No. of credits",
    "Location",
    "Registry",
    "Status",
  ];

  const headerData2 = [
    "Project Name",
    "Project ID",
    "Category",
    "No. of credits",
    "Location",
    "Registry",
    "Add more credits",
  ];
  const pageSize = 10;
  const navigate = useNavigate();

  const handleAddCreditOpen = (rowData) => {
    if (rowData && rowData["Project Name"] && rowData["Project ID"]) {
      setSelectedRowData({
        "Project Name": rowData["Project Name"],
        "Project Id": rowData["Project ID"],
        _id: rowData["_id"],
      });
      setAddCreditOpen(true);
    } else {
      console.error("Invalid rowData:", rowData);
    }
  };

  const handleAddCreditSubmitOpen = async (data) => {
    setIsLoading(true);
    try {
      const response = await addMoreCredit(data, dispatch);
      // console.log(response, "success");
      if (response.success) {
        toast.success(
          response.message || "add More Credit requested successfully"
        );
        fetchData();
      } else {
        toast.error(
          response.message || "Failed to create  add  More Credit request "
        );
      }
    } catch (error) {
      toast.error("Failed to create  add  More Credit request");
    } finally {
      setIsLoading(false);
    }

    setAddCreditOpen(false);
  };

  const handleAddCreditClose = () => {
    setAddCreditOpen(false);
  };

  const handleAddCreditSubmitOk = () => {
    setSelectedToggle("Ongoing");
    setAddCreditSubmit(false);
  };

  const handleAddCreditSubmitNotOk = () => {
    setAddCreditSubmit(false);
  };

  const handleAddCreditSubmitClose = () => {
    setAddCreditSubmit(false);
  };

  const handleToggleBill = (toggleType) => {
    if (toggleType == "Complete") {
      setFilterData({ status: "verified" });
    } else {
      setFilterData(null);
    }
    setSelectedToggle(toggleType);
  };

  const transformDataForAddCredits = (originalData, selectedToggle) => {
    return originalData.paginatedData.map((project) => ({
      "Project Name": (
        <p
          className=" text-sm cursor-pointer"
          onClick={() => {
            navigate(`/project/${project._id}`, { state: { fromProjectsPage: true } });
          }}
        >
          {project["Project Name"]}
        </p>
      ),
      "Project ID": project["Project ID"],
      Category: project["Category"],
      "No. of credits": project["Number Of Credits"],
      Location: project["Location"],
      // Registry: project.Registry["registryName"],
      Registry:
        selectedToggle === "Complete"
          ? project["Registry"]
          : project.Registry["registryName"],
      ...(selectedToggle === "Complete"
        ? {
            Action: (
              <ActionButtons
                addCreditButtonHandler={() => handleAddCreditOpen(project)}
              />
            ),
          }
        : {
            Status: project["Status"],
            StatusButton: (
              <div
                className={` ${
                  project.Status === "action_required" && "cursor-pointer"
                } || ${project.Status === "not_verified" && "cursor-pointer"}`}
                onClick={() => {
                  if (project.Status === "action_required") {
                    navigate(`/project/${project._id}`);
                  }
                  if (project.Status === "not_verified") {
                    setShowRemarksPopup(true);
                    setProjectId(project._id);
                  }
                }}
              >
                <Badge varient={project.Status}>
                  <div className="flex justify-center items-center w-36 text-xs h-5 ">
                    {getLabel[project.Status]}
                  </div>
                </Badge>
              </div>
            ),
          }),
    }));
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await yourProjetsData(
        {
          filterData: filterData,
          page: currentPage,
          pageSize,
          searchQuery: searchItem,
        },
        dispatch
      );
      if (response.success) {
        const transformedData = transformDataForAddCredits(
          response.data,
          selectedToggle
        );
        setProjectsData(transformedData);
        setPagination({
          totalItems: response.data.totalDocs,
          totalPages: response.data.totalPages,
        });
      } else {
        toast.error(response.message || "Failed to fetch projects");
      }
    } catch (error) {
      toast.error("Failed to fetch projects");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [selectedToggle, currentPage, filterData, searchItem]);

  const [showKycComplete, setShowKycComplete] = useState(false);
  const { kycVerified } = useSelector((state) => state.authReducer);

  const kycOkHandler = () => {
    setShowKycComplete(false);
    navigate("/kyc");
  };

  const kycCancelHandler = () => {
    setShowKycComplete(false);
  };

  const onUploadProject = () => {
    if (!kycVerified) {
      setShowKycComplete(true);
    } else {
      navigate("/upload-project");
    }
  };

  const handleSearch = () => {
    // console.log(searchItem);
  };

  const handleFilterButtonClick = () => {
    setFilterDialogOpen(true);
  };

  const handleFilterDialogClose = () => {
    setSelectedRegistry(null);
    setSelectedCategory(null);
    // setSelectedToken("");
    setSelectedCountry(null);
    setSelectedStatus(null);
    setFilterData(null);
    setFilterDialogOpen(false);
  };

  const handleFilterDialogSubmit = () => {
    setFilterDialogOpen(false);
    setFilterData({
      categoryId: selectedCategory,
      registries: selectedRegistry ? [selectedRegistry] : null,
      country: selectedCountry,
      status: selectedStatus,
    });
  };

  const handlePendingButtonClick = (selectedProject) => {
    navigate("/upload-project?actionRequired=true");
  };

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    setSelectedCategory(selectedCategory);
  };

  const handleCountryChange = (event) => {
    {
      setSelectedCountry(event.target.value);
    }
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  const handleRegistryCheck = (e) => {
    {
      const selectedValue = e.target.value;
      setSelectedRegistry(selectedValue);
    }
  };

  return (
    <>
      <AcceptPopUp
        open={showKycComplete}
        onCancel={kycCancelHandler}
        notOk={kycCancelHandler}
        onOk={kycOkHandler}
        title={"Please Complete your KYC First !"}
        okButtonText={"Ok"}
        cancelButtonText={"Cancel"}
      />
      {showCompletePage ? (
        <TransitionWrapper>
          <div className="flex h-full flex-col p-6 pl-3 w-full bg-gray-100">
            <div className="text-2xl font-bold mb-4">Your Projects</div>
            <div className="w-full mt-8 h-[calc(90vh-2.4rem)] bg-white rounded-3xl shadow-formShadow flex flex-col">
              <div className="flex justify-between pt-5">
                <div className="w-80 border-2 border-grey-800 rounded-lg mx-5 mb-5 ">
                  <SearchBar
                    onSearch={handleSearch}
                    searchItem={searchItem}
                    setSearchItem={setSearchItem}
                    variant="secondaryxl"
                    className="text-black"
                    borderColor="border-none"
                    placeholderColor="black"
                    inputBackground="white"
                    svgStrokeColor="black"
                    inputWidth="72"
                    inputHeight="8"
                  />
                </div>
                <div className="flex gap-6 pr-4">
                  <Button
                    varient="primary"
                    borderColor={"blue"}
                    color="blue"
                    onClick={onUploadProject}
                    className="text-base text-white font-bold px-6 mb-3"
                  >
                    <div className="flex gap-x-2 items-center">
                      <UploadProject className="w-4 h-4" />
                      <span>Upload Project</span>
                    </div>
                  </Button>
                  <Button
                    className="flex justify-center items-center px-2 mb-3"
                    borderColor={"gray"}
                    varient={"secondary"}
                    onClick={handleFilterButtonClick}
                  >
                    <div className="flex gap-x-2 items-center">
                      <Filter className="w-4 h-4" />
                      <span>Filter</span>
                    </div>
                  </Button>
                </div>
              </div>
              <div className="px-6">
                <ToggleButton
                  disabled={isLoading}
                  label="Ongoing"
                  isActive={selectedToggle === "Ongoing"}
                  onClick={() => handleToggleBill("Ongoing")}
                />
                <ToggleButton
                  disabled={isLoading}
                  label="Complete"
                  isActive={selectedToggle === "Complete"}
                  onClick={() => handleToggleBill("Complete")}
                />
              </div>
              <div className="mt-7 flex-grow overflow-y-auto">
                {isLoading ? (
                  <>
                    <CustomTable
                      data={[]}
                      headerData={
                        selectedToggle === "Complete"
                          ? headerData2
                          : headerData1
                      }
                    />
                    <div className="flex flex-col gap-y-4 p-4">
                      <Skeleton.Button block={true} active={true} />
                      <Skeleton.Button block={true} active={true} />
                      <Skeleton.Button block={true} active={true} />
                      <Skeleton.Button block={true} active={true} />
                    </div>
                  </>
                ) : (
                  <CustomTable
                    data={
                      selectedToggle === "Complete"
                        ? Array.isArray(projectsData)
                          ? projectsData.map((project) =>
                              Object.values(project)
                            )
                          : []
                        : Array.isArray(projectsData)
                        ? projectsData.map((project) =>
                            Object.values(project).filter(
                              (_, index) =>
                                index !== headerData1.indexOf("Status")
                            )
                          )
                        : []
                    }
                    headerData={
                      selectedToggle === "Complete" ? headerData2 : headerData1
                    }
                  />
                )}

                <AddCreditsPopup
                  open={isAddCreditOpen}
                  onCancel={handleAddCreditClose}
                  onOk={handleAddCreditSubmitOpen}
                  selectedRowData={selectedRowData}
                  selectedColumns={["Project Name", "Project Id"]}
                />
                <AcceptPopUp
                  open={isAddCreditSubmit}
                  onCancel={handleAddCreditSubmitClose}
                  onOk={handleAddCreditSubmitOk}
                  notOk={handleAddCreditSubmitNotOk}
                  title="Your Request Initiated!"
                  statusType="Check the Status in Your Projects Ongoing tab"
                  isRequiredColor="green"
                  okButtonText="Go To Your Projects"
                  cancelButtonText="Go Back"
                />
              </div>
              {pagination.totalPages > 1 && (
                <div className="px-4">
                  <Pagination
                    className={"mb-4"}
                    current={currentPage}
                    total={pagination.totalItems}
                    pageSize={pageSize}
                    setCurrentPage={(page) => setSearchParams({ page })}
                  />
                </div>
              )}
            </div>
            {isFilterDialogOpen && (
              <FilterBox
                open={isFilterDialogOpen}
                onCancel={handleFilterDialogClose}
                onOk={handleFilterDialogSubmit}
                page="projects"
                selectedRegistry={selectedRegistry}
                onCheckRegistry={handleRegistryCheck}
                selectedCategory={selectedCategory}
                onSelectCategory={handleCategoryChange}
                selectedCountry={selectedCountry}
                onSelectedCountry={handleCountryChange}
                selectedStatus={selectedStatus}
                onSelectedStatus={handleStatusChange}
                // selectedToken={selectedToken}
                // onSelectToken={handleTokenChange}
              />
            )}
          </div>
        </TransitionWrapper>
      ) : (
        <div className="w-full h-fit">
          <CustomTable
            data={
              Array.isArray(projectsData)
                ? projectsData.map((project) => Object.values(project))
                : []
            }
            headerData={
              selectedToggle === "Complete" ? headerData2 : headerData1
            }
          />
        </div>
      )}
      {showRemarksPopup && (
        <ProjectsRemarks
          open={showRemarksPopup}
          onCancel={() => {
            setShowRemarksPopup(false);
          }}
          projectId={projectId}
        />
      )}
    </>
  );
};

export default ProjectsPage;
